import React from "react";

const FormField = ({ label, value, className }) => {
  return (
    <div className="mb-4">
      <label className="block text-base font-medium text-[#1C3664] mb-2">
        {label}
      </label>
      <div className={`text-base ${className || "text-[#626262]"}`}>
        {value || "NA"}
      </div>
    </div>
  );
};

export default FormField;
